document.addEventListener("DOMContentLoaded", () => {
    function updateCountdown() {
        const timer_block = document.querySelector('.pdp-block-delivery-timer');

        if (timer_block) {

            const monday_text = timer_block.getAttribute('data-monday-text');
            const tuesday_text = timer_block.getAttribute('data-tuesday-text');
            const holiday_text = timer_block.getAttribute('data-holiday-text');
            const time_passed_text = timer_block.getAttribute('data-time-passed-text');

            const targetHour = parseInt(document.querySelector('#delivery-countdown').getAttribute('data-target-time'));
            const targetMinute = 0;

            const targetTime = new Date();
            targetTime.setUTCHours(targetHour, targetMinute, 0); // Set the target time to 7:00 PM GMT

            let currentTime = new Date();
            // currentTime.setDate(currentTime.getDate() + 1);

            const urlParams = new URLSearchParams(window.location.search);
            const timeParam = urlParams.get('day');
            if (timeParam != null && (timeParam >= 0 && timeParam <= 7)) {
                const today = new Date();
                today.setHours(13, 0, 0);
                const daysUntil = (timeParam - today.getDay() + 7) % 7;
                currentTime.setDate(today.getDate() + daysUntil);
            }

            const dayOfWeek = currentTime.getUTCDay(); // Get the current day of the week (0 = Sunday, 6 = Saturday)
            // Check if today is Friday (dayOfWeek = 5)
            if (dayOfWeek === 5) {
                document.getElementById('next-day-warning').textContent = monday_text;
                document.querySelector('.tomorrow').style.display = 'none';
            }

            if (dayOfWeek === 6) {
                document.getElementById('delivery-countdown').textContent = tuesday_text;
                document.querySelector('.tomorrow').style.display = 'none';
                document.querySelector('.order-in').style.display = 'none';
                return;
            }

            if (dayOfWeek === 0) {
                document.getElementById('delivery-countdown').textContent = tuesday_text;
                document.querySelector('.tomorrow').style.display = 'none';
                document.querySelector('.order-in').style.display = 'none';
                return;
            }


            // Bank holidays
            const holidayString = document.querySelector('.pdp-block-delivery-timer').getAttribute('data-holiday-dates');
            const bankHolidays = holidayString.split(',').map(date => date.trim());

            const formattedBankHolidays = bankHolidays.map(date => {
                const [day, month, year] = date.split('-');
                return new Date(Date.UTC(year, month - 1, day)); // Month is 0-based in JavaScript dates
            });

            // Check if tomorrow is a bank holiday
            const tomorrow = new Date(currentTime);
            tomorrow.setDate(currentTime.getDate());
            if (formattedBankHolidays.some(holiday => holiday.toDateString() === tomorrow.toDateString())) {
                document.querySelector('.tomorrow').style.display = 'none';
                document.querySelector('.order-in').style.display = 'none';
                document.getElementById('next-day-warning').textContent = holiday_text;
                return;
            }

            const timeDifference = targetTime - currentTime;

            if (timeDifference <= 0) {
                if (dayOfWeek === 1 || dayOfWeek === 2 || dayOfWeek === 3 || dayOfWeek === 4) {
                    document.getElementById('delivery-countdown').textContent = time_passed_text;
                    return;
                } else if (dayOfWeek === 5) {
                    document.getElementById('delivery-countdown').textContent = tuesday_text;
                    document.querySelector('.tomorrow').style.display = 'none';
                    document.querySelector('.order-in').style.display = 'none';
                    document.getElementById('next-day-warning').style.display = 'none';
                    return;
                }

            }

            const hours = Math.floor(timeDifference / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            const countdownElement = document.getElementById('delivery-countdown');
            countdownElement.innerHTML =
            ('0' + hours).slice(-2) + ' hrs <span class="separator">|</span> ' +
            ('0' + minutes).slice(-2) + ' min <span class="separator">|</span> ' +
            ('0' + seconds).slice(-2) + ' sec';

            setTimeout(updateCountdown, 1000); // Update every second
        }
    }

    updateCountdown(); // Initial call to start the countdown

});